export default __webpack_public_path__ + "static/media/todos-color.0d111f60.svg";